import React from 'react';
export default (function () {
  return /*#__PURE__*/React.createElement("div", null);
});